import React from "react";
import Menu from "./Menu";

const MenuProvider = () => {
  return <Menu />;
};

export default MenuProvider;
